import { IApi } from '../../api'
import { createRequestTypes } from '../../helpers/helpers'
import { createAction } from '../types'

export const prefix = 'teams'

export const [LIST_TEAMS_REQUEST, LIST_TEAMS_SUCCESS, LIST_TEAMS_FAILURE] = createRequestTypes(
  prefix,
  'LIST_TEAMS',
)

export const listTeams = createAction((params?: object) => ({
  type: [LIST_TEAMS_REQUEST, LIST_TEAMS_SUCCESS, LIST_TEAMS_FAILURE],
  promise: (api: IApi) => api.teams.list(params),
}))

export const [CREATE_TEAM_REQUEST, CREATE_TEAM_SUCCESS, CREATE_TEAM_FAILURE] = createRequestTypes(
  prefix,
  'CREATE_TEAM',
)

export const createTeam = createAction((data: object) => ({
  type: [CREATE_TEAM_REQUEST, CREATE_TEAM_SUCCESS, CREATE_TEAM_FAILURE],
  promise: (api: IApi) => api.teams.create(data),
}))

export const [UPDATE_TEAM_REQUEST, UPDATE_TEAM_SUCCESS, UPDATE_TEAM_FAILURE] = createRequestTypes(
  prefix,
  'UPDATE_TEAM',
)

export const updateTeam = createAction((id: string, data: object) => ({
  type: [UPDATE_TEAM_REQUEST, UPDATE_TEAM_SUCCESS, UPDATE_TEAM_FAILURE],
  promise: (api: IApi) => api.teams.update(id, data),
}))

export const [DELETE_TEAM_REQUEST, DELETE_TEAM_SUCCESS, DELETE_TEAM_FAILURE] = createRequestTypes(
  prefix,
  'DELETE_TEAM',
)

export const deleteTeam = createAction((id: string) => ({
  type: [DELETE_TEAM_REQUEST, DELETE_TEAM_SUCCESS, DELETE_TEAM_FAILURE],
  promise: (api: IApi) => api.teams.delete(id),
}))

export const [SET_USER_TEAMS_REQUEST, SET_USER_TEAMS_SUCCESS, SET_USER_TEAMS_FAILURE] =
  createRequestTypes(prefix, 'SET_USER_TEAMS')

export const setUserTeams = createAction((userId: string, teamIds: string[]) => ({
  type: [SET_USER_TEAMS_REQUEST, SET_USER_TEAMS_SUCCESS, SET_USER_TEAMS_FAILURE],
  promise: (api: IApi) => api.teams.setUserTeams(userId, teamIds),
}))
